import { Button, TextInput } from '@triumph/design-system';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageRoutes } from '@/app/components/router/routes';
import { resendActivationEmail } from '@/app/shared/api/endpoints/resendActivation';
import {
  BackLink,
  ConfirmationContainer,
  ConfirmationMessage,
  Description,
  FormGroup,
  ResendActivationContainer,
  Title,
} from './ResendActivation.StyledComponents';

export const ResendActivation = () => {
  const { t } = useTranslation('authentication');
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    resendActivationEmail(email);
    setSubmitted(true);
  };

  const handleBackToSignIn = () => {
    navigate(PageRoutes.LOGIN);
  };

  const handleSendAnother = () => {
    setEmail('');
    setSubmitted(false);
  };

  if (submitted) {
    return (
      <ResendActivationContainer>
        <Title>{t('resendActivation.title')}</Title>
        <ConfirmationContainer>
          <ConfirmationMessage>
            {t('resendActivation.confirmationMessage')}
          </ConfirmationMessage>
          <BackLink onClick={handleBackToSignIn}>
            {t('resendActivation.backToSignIn')}
          </BackLink>
        </ConfirmationContainer>
      </ResendActivationContainer>
    );
  }

  return (
    <ResendActivationContainer>
      <Title>{t('resendActivation.title')}</Title>
      <Description>{t('resendActivation.description')}</Description>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <TextInput
            label={t('resendActivation.emailLabel')}
            type="email"
            placeholder={t('resendActivation.emailPlaceholder')}
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            required
          />
        </FormGroup>
        <Button type="submit" disabled={!email}>
          {t('resendActivation.sendButton')}
        </Button>
      </form>
      <BackLink onClick={handleBackToSignIn}>
        {t('resendActivation.backToSignIn')}
      </BackLink>
    </ResendActivationContainer>
  );
};
